import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=8f12efb4"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f12efb4')) {
      api.createRecord('8f12efb4', component.options)
    } else {
      api.reload('8f12efb4', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=8f12efb4", function () {
      api.rerender('8f12efb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/Editor.vue"
export default component.exports